import * as React from "react";

function SvgErrorSmall(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width={15} height={12.335} {...props}>
        <g data-name="Group 11583" fill="#f44336">
          <path data-name="Path 43362" d="M7.505 0l-7.5 12.335h15zm0 1.638l5.946 9.779H1.554z" />
          <g data-name="Group 11144">
            <path
              data-name="Path 43363"
              d="M7.538 8.715a.468.468 0 00.466-.467V4.609a.467.467 0 00-.466-.466.467.467 0 00-.466.466v3.643a.468.468 0 00.466.463z"
            />
            <path data-name="Path 43364" d="M7.539 9.203a.516.516 0 10.516.516.516.516 0 00-.516-.516z" />
          </g>
        </g>
      </svg>
    </span>
  );
}

export default SvgErrorSmall;
